import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import ExpenseReportsChild from "./ExpenseReportsChild";

const ExpenseReports = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ExpenseReportsChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ExpenseReports;
